import { getShouldShowCourseReset } from 'utils/storage';

const env = import.meta.env;

const buildNumber = env.VITE_CODEBUILD_BUILD_NUMBER;
const sentryEnv = env.VITE_SENTRY_ENV;
const tenantId = env.VITE_TENANT_ID;
const wafCaptcha = env.VITE_WAF_API_URL;
const wafApiKey = env.VITE_WAF_API_KEY;
const showCourseReset = env.VITE_SHOW_COURSE_RESET;

export const Config = {
  /** Tenant ID for API requests. */
  tenantId,
  /** Base URL for API. */
  baseURL: env.VITE_BASE_URL,
  /** Show tenant logo in the top navigation bar and on login page */
  showTenantLogo: env.VITE_SHOW_TENANT_LOGO === 'true',
  /** Login by guest ID */
  isLoginByGuestId: env.VITE_LOGIN_BY_GUEST_ID === 'true',
  /** i18n key for the welcome title on the dashboard (e.g. 'welcomeTitle' | 'welcomeTitleSeahlAdmin') */
  welcomeTextKey: env.VITE_WELCOME_TEXT_KEY || 'welcomeTitle',
  /** Show funding acknowledgment button in the top navigation */
  showFundingAcknowledgment: env.VITE_SHOW_FUNDING_ACKNOWLEDGMENT === 'true',
  /** i18n key for the download certificate button (e.g. 'downloadCertificate' | 'downloadActionPlan') */
  downloadCertificateKey:
    env.VITE_DOWNLOAD_CERTIFICATE_KEY || 'downloadCertificate',
  /** AWS WAF */
  waf: {
    apiKey: wafApiKey,
    apiUrl: wafCaptcha,
    enabled: !!wafCaptcha && !!wafApiKey,
  },
  /** Show course restart button on the dashboard */
  showCourseReset:
    typeof showCourseReset === 'string'
      ? showCourseReset === 'true'
      : getShouldShowCourseReset(),
  /** Languages for translation */
  supportedLanguages:
    env.VITE_SUPPORTED_LANGUAGES?.split(',')
      .map((lang) => lang.trim())
      .filter(Boolean) ?? [],
  /** Sentry  configuratiin **/
  sentry: {
    env: sentryEnv,
    dsn: env.VITE_SENTRY_DSN,
    release:
      sentryEnv && buildNumber
        ? `${sentryEnv}-${tenantId}-${buildNumber}`
        : undefined,
  },
};
